<script setup>
import { computed } from 'vue'

const props = defineProps({
  style: {
    type: String,
    default: 'primary',
  },
  to: {
    type: [String, Object],
    default: null,
  },
  disable: {
    type: Boolean,
    default: false,
  },
  attributes: Object,
})

const variantClasses = {
  primary:
    'rounded-lg bg-primary px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-ep-blue-500 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
  secondary:
    'rounded-lg bg-white px-4 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 hover:ring-gray-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
  destructive:
    'rounded-lg bg-red-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
  signin:
    'flex w-full justify-center rounded-lg bg-primary px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-ep-blue-500 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
  copybutton: 'rounded-lg invisible sm:visible px-2.5 py-2.5 text-sm font-semibold text-blue-500 shadow-sm hover:bg-blue-200 border border-blue-600',
  dark: 'rounded-lg bg-white/10 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-white/20',
  grayed: 'rounded-lg bg-gray-200 px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-300',
}

const buttonClass = computed(() => {
  const base = 'transition-all duration-200 ease-in-out active:scale-[0.98]'
  const variant = variantClasses[props.style] || variantClasses.primary
  const disabled = props.disable ? ' opacity-50 cursor-not-allowed active:scale-100' : ''
  return `${base} ${variant}${disabled}`
})
</script>

<template>
  <router-link
    v-if="props.to"
    :class="buttonClass"
    :to="props.to"
    :target="props.target"
    :disabled="disable"
    :style="{ backgroundColor: props.attributes?.primary_color || null }"
  >
    <slot />
  </router-link>
  <button v-else :class="buttonClass" :disabled="disable" :style="{ backgroundColor: props.attributes?.primary_color || null }">
    <slot />
  </button>
</template>
